var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStoreGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0H3.55379C3.18575 0 2.81771 0.210938 2.61696 0.527344L0.475634 4.18359C-0.661945 6.08203 0.341801 8.68359 2.41621 8.96484C2.5835 9 2.71733 9 2.88463 9C3.88837 9 4.75829 8.54297 5.36053 7.83984C5.96278 8.54297 6.8327 9 7.83644 9C8.66578 9 9.42179 8.66611 10 8.13004V0Z",
    fill: "#9296AC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 13.5H5.00357V10.0195C4.66899 10.0898 3.21921 10.125 2.88463 10.125C2.68388 10.125 2.48313 10.125 2.28238 10.0898C2.08163 10.0547 1.91434 10.0195 1.74705 9.98438V16.875C1.74705 17.5078 2.21546 18 2.81771 18H10V13.5Z",
    fill: "#9296AC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 0H16.4462C16.8142 0 17.1823 0.210938 17.383 0.527344L19.5244 4.18359C20.6619 6.08203 19.6582 8.68359 17.5838 8.96484C17.4165 9 17.2827 9 17.1154 9C16.1116 9 15.2417 8.54297 14.6395 7.83984C14.0372 8.54297 13.1673 9 12.1636 9C11.3342 9 10.5782 8.66611 10 8.13004V0Z",
    fill: "#9296AC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10 13.5H14.9964V10.0195C15.331 10.0898 16.7808 10.125 17.1154 10.125C17.3161 10.125 17.5169 10.125 17.7176 10.0898C17.9184 10.0547 18.0857 10.0195 18.253 9.98438V16.875C18.253 17.5078 17.7845 18 17.1823 18H10V13.5Z",
    fill: "#9296AC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStoreGray);
export default __webpack_public_path__ + "static/media/storeGray.10f97b5f76b39aa435dc8118e0bf105d.svg";
export { ForwardRef as ReactComponent };